import React from 'react';
import StaffLogin from '@/components/StaffLogin';

const POSLogin = () => {
  return (
    <StaffLogin
      role="pos"
      title="POS System Login"
      description="Enter your staff password to access the billing system"
      redirectTo="/pos"
    />
  );
};

export default POSLogin;